import { ReschedulerData } from './types';

export const initialState: ReschedulerData = {
  open: false,
  showSummary: false,
  remove: '',
  relatedSchedules: [],
  savedSchedules: [],
  schedule: {},
  scheduleSummary: {},
};
